import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicVoucher({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13 2.75H3c-.97 0-1.75.78-1.75 1.75v2.55H2a.95.95 0 010 1.9h-.75v2.55c0 .97.78 1.75 1.75 1.75h10c.97 0 1.75-.78 1.75-1.75V8.95H14a.95.95 0 010-1.9h.75V4.5c0-.97-.78-1.75-1.75-1.75zm0 1.5h.06c.1.03.19.13.19.25v1.17h-.02A2.45 2.45 0 0011.55 8v.16a2.45 2.45 0 001.68 2.17h.02v1.17c0 .14-.11.25-.25.25H2.94a.25.25 0 01-.19-.25v-1.17h.02A2.45 2.45 0 004.45 8v-.16a2.45 2.45 0 00-1.68-2.17h-.02V4.5c0-.14.11-.25.25-.25h10zM6.75 5.5c.41 0 .75.34.75.75v3.5a.75.75 0 11-1.5 0v-3.5c0-.41.34-.75.75-.75z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicVoucher.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicVoucher.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicVoucher svgRef={ref} {...props} />);
export default ForwardRef;
